import React from 'react';
import { DealTooltipProvider } from '@/creditflowresearch/application/Deal/contexts/DealTooltipContext';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import { useParentPageContext } from '@/creditflowresearch/application/ParentPageContext';
import DealPageContextProvider from '@/creditflowresearch/application/Deal/contexts/DealPageContext';

export interface ITileWrapperProps {
  children?: React.ReactNode,
  requiredUserPlan?: UserPlanType,
}

export const withDealPageContext = <P extends object>(
  Component: React.ComponentType<P>,
) => {
  const WithDealPageContext: React.FC<P & ITileWrapperProps> = (props) => {
    const { deal } = useParentPageContext();

    return (
      <DealPageContextProvider deal={ deal }>
        <DealTooltipProvider>
          <Component { ...props as P } />
        </DealTooltipProvider>
      </DealPageContextProvider>
    );
  };

  return WithDealPageContext;
};
